import React, { useContext } from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import styled from 'styled-components';
import { isMobile } from 'react-device-detect';
import { AuthContext } from '../context/auth';
import { LinearProgress } from '@material-ui/core';

export const LoadingWrapper = styled.div`
    margin-top: ${isMobile ? '56px' : '64px'};
`;

interface PrivateRouteProps extends RouteProps {
    component: React.FC;
    adminAccess?: boolean;
}

interface routeCheckProps {
    props: {}, 
    token: string | null,
    pageAdmin?: boolean,
    userAdmin?: Boolean
}

export function PrivateRoute(props: PrivateRouteProps) {
    const { adminAccess, component: Component, ...rest } = props;
    const { user, isLoading, authToken } = useContext(AuthContext);
    const routeCheck = ({props, token, pageAdmin, userAdmin}: routeCheckProps) => {
        if (token && pageAdmin && userAdmin)
            return <Component {...props} />
        else if (token !== null)
            return <Component {...props} />
        else 
            return <Redirect to={{pathname: `${process.env.REACT_APP_INTERNAL_URL}`}} />
    }
    return (
        <Route
            render={(routeProps) =>
                isLoading
                    ? <LoadingWrapper><LinearProgress /></LoadingWrapper>
                    : routeCheck({
                        props: routeProps,
                        token: authToken,
                        pageAdmin: adminAccess,
                        userAdmin: user?.isAdmin
                    })
            }
            {...rest}
        />
    );
}
